import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Typography, } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
  },
  title: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));

const PageTitle = props => {
  const { pageTitle } = props;

  const classes = useStyles();

  return (
    <div>
      <div className={classes.title}>
        <Typography
          variant="h2"
          gutterBottom
        >
          {pageTitle}
        </Typography>
      </div>
    </div>
  );
};

PageTitle.propTypes = {
  pageTitle: PropTypes.string,
};

export default PageTitle;
